module.exports = __webpack_public_path__ + "img/icon-whats-online.7626a3cd.png";